import React, { useEffect, useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Chart } from 'primereact/chart';
import { InputSwitch } from 'primereact/inputswitch';
import { leaveService } from '../../../services/extensions';
import { Panel } from 'primereact/panel';
import { Button } from 'primereact/button';
import { capitalize } from '../../../services/utility/helper';
import { Util } from '../../../services';
import { toast } from 'react-toastify';
import { utitService } from '../../../services/util';
import '../styles/manager-home.scss';
import { Knob } from 'primereact/knob';
import {
    generateRandomColor, processMonthlyLeaves, getAbsenceCodesLocationWise, getLeaveTypesByUserLocation,
    chartData, basicOptionsbasicOptions, lineChartOptions, yearChartData
} from '../controllers/employee-controller';
import { Status, LeaveStatus } from '../../../common/util/constants';
import { LeaveYearChart } from './leave-year-chart';
import { useSelector, useDispatch } from 'react-redux';
import { selectUser, selectData } from '../../../services/store/userSlice';


const ManagerHome = ({ date }) => {
    const user = useSelector(selectUser);
    const userData = useSelector(selectData);
    const [showDataTable, setShowDataTable] = useState(false);
    const [approvedCount, setApprovedCount] = useState(0);
    const [reviewCount, setReviewCount] = useState(0);
    const [rejectCount, setRejectCount] = useState(0);
    const [totalRequests, setTotalRequests] = useState(0);
    const [chartData, setChartData] = useState(null);
    const [tableData, setTableData] = useState({});
    const [userOnLeaveCurrentDate, setUserOnLeaveCurrentDate] = useState([]);
    const [totalUserLeaveCount, setTotalUserLeaveCount] = useState({});
    const [totalYearUserLeaves, setTotalYearUserLeaves] = useState([]);
    const [usersOnLeaveCount, setUsersOnLeaveCount] = useState(0);
    const [celebrationsData, setCelebrationsData] = useState([]);
    const icons = { review: 'pi-clock', approved: 'pi-check', rejected: 'pi-times', total: 'pi-calculator' }
    const colors = { review: '#42A5F5', approved: '#66BB6A', rejected: '#ff6347', total: '#ccc' }
    const [leaveTeken, setLeaveTaken] = useState({ labels: ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'], datasets: [] });
    const leaveColor = [{ SL: '#00ba0d' }, { CL: '#f4b444' }, { RH: '#92f444' }, { EL: '#44f4e3' }, { ML: '#cf44f4' }, { BL: '#ff0000' }, { LWP: '#f45d44' }, { PL: '#4445f4' },];
    const [lightOptions] = useState({
        plugins: {
            legend: {
                labels: { color: '#495057' },
                position: 'bottom',
                display: false
            }
        }
    });
    let currentDate = Util.dateConverterForLeave(new Date());

    useEffect(() => {
        getDashboardCount();
        fetchUserLeaveOnCurrentDate();
        fetchTotalUserLeaveCount();
        // fetchCelebrationsData();
    }, []);

    useEffect(() => {
        fetchCelebrationsData();
        getDashboardCount();
    }, [date]);

    const getDashboardCount = async () => {
        try {
            const response = await leaveService.GetUserLeavesBySuperiorcount(utitService.dateParser(date, 'YYYY-MM-DD'));
            const { approved, rejected, review, total } = response?.data?.data?.leaveStatusCounts;
            setTableData(response?.data?.data?.leaveStatusCounts);
            setApprovedCount(approvedCount);
            setRejectCount(rejectCount);
            setReviewCount(reviewCount);
            setTotalRequests(totalRequests);
            setChartData({
                labels: ['Approved', 'Review', 'Rejected'],
                datasets: [
                    {
                        data: [approved, review, rejected],
                        backgroundColor: [colors.approved, colors.review, colors.rejected],
                        hoverBackgroundColor: [colors.approved, colors.review, colors.rejected]
                    }
                ]
            });
        } catch (error) {
            console.error('Error fetching dashboard counts:', error);
        }
    };

    const fetchUserLeaveOnCurrentDate = () => {
        leaveService.GetUserleavesDetailsOnSameDay().then(resp => {
            try {
                setUserOnLeaveCurrentDate(resp.data.usersOnLeave);
                setUsersOnLeaveCount(resp.data.usersOnLeaveCount);
            } catch (error) {
                toast.error('Cannot fetch users on leave today');
            }
        });
    };

    const fetchTotalUserLeaveCount = async () => {
        try {
            const response = await leaveService.GetUserLeavesBySuperiorcount(utitService.dateParser(date, 'YYYY-MM-DD'));
            setTotalUserLeaveCount(response.data.totalLeaveCount);
            const resp = await leaveService.getLeavesAbsenceBySuperiorcount(utitService.dateParser(date, 'YYYY-MM-DD'));
            setTotalYearUserLeaves(resp.data.data.leaves);
            // console.log(">>>>", resp.data.data.leaves)
            updateYearlyChartData(resp.data.data.leaves)
        } catch (error) {
            console.error('Error fetching total user leave count:', error);
        }
    };

    const updateYearlyChartData = (data) => {
        let leaveObj = [];
        if (userData) {
            const tookLeave = data || [];
            const ult = userData.userAbsenceCodes;
            for (let item of ult) {
                const obj = {
                    label: item.code,
                    data: processMonthlyLeaves(tookLeave, item),
                    fill: false,
                    borderColor: leaveColor[item.code],
                    backgroundColor: leaveColor[item.code],
                    tension: .4
                }
                leaveObj.push(obj);
            }
            setLeaveTaken({ ...leaveTeken, datasets: leaveObj });
        }
    }

    const fetchCelebrationsData = async () => {
        try {
            const response = await leaveService.GetUserBirthdayAndAnnviversaryBySuperior(utitService.dateParser(date, 'YYYY-MM-DD'));
            setCelebrationsData(response.data.data);
        } catch (error) {
            console.error('Error fetching celebrations data:', error);
        }
    };

    const userNameBody = (rowData) => {
        return <strong>{capitalize(rowData.firstName) + " " + capitalize(rowData.lastName)}</strong>;
    };

    const absCodeBody = (rowData) => {
        return <p>{rowData.Leaves[0].absenceCode}</p>;
    };

    const leaveTypeBody = (rowData) => {
        return <p>{rowData.Leaves[0].leaveType}</p>;
    };

    const renderResourceLeaves = () => {
        return (<div className='ess-db-card ess-resource-leave '>
            <h1>Today's Resource Leaves ({utitService.dateParser(new Date(), 'DD-MM-YYYY')})</h1>
            <DataTable value={userOnLeaveCurrentDate}>
                <Column header='Team Member' body={userNameBody}></Column>
                <Column header='Absence Code' body={absCodeBody}></Column>
                <Column header='Leave Type' body={leaveTypeBody}></Column>
            </DataTable>
        </div>)
    }
    const renderCelebrations = () => {
        return (<div className='ess-db-card ess-resource-leave '>
            <h1>This month's celebrations</h1>
            <DataTable value={celebrationsData} stripedRows>
                <Column field='ecn' header='ECN' headerStyle={{ width: '80px' }} bodyStyle={{ width: '80px' }} body={(r) => (<strong>{r.ecn}</strong>)}></Column>
                <Column header='Team Member' body={userNameBody}></Column>
                <Column field="event" header="Event" headerStyle={{ width: '120px', textAlign: 'center' }} bodyStyle={{ width: '120px', textAlign: 'center' }} />
                <Column field="eventDate" header="Date" headerStyle={{ width: '120px', textAlign: 'center' }} bodyStyle={{ width: '120px', textAlign: 'center' }}
                    body={(r) => (utitService.dateWithMonthConverter(r.eventDate))} />
            </DataTable>
        </div>)
    }
    const renderAgregateLeaves = () => {
        return (<div className='ess-db-card ess-resource-leave' >
            <h1 style={{ textAlign: 'center', marginTop: '15px', marginBottom: '15px' }}>Month wise leave requests ({utitService.dateParser(date, 'MMMM')})</h1>
            <div className='col-12 p-3'>
                <div className='ess-card-wrapper'>
                    {/* <div className='col-fixed ess-card' style={{ width: '110px' }}>
                        <div className='card' style={{ width: '100px' }}>
                            <div className="flex justify-content-center">
                                <Chart type="doughnut" data={chartData} options={lightOptions} style={{ position: 'relative', width: '100%' }} />
                            </div>
                        </div>
                    </div> */}
                    {Object.keys(tableData).map(k => (<div className='ess-card' >
                        <div className='card'>
                            {/* <span className='icon' style={{ background: colors[k], color: '#fff' }}><i className={'pi ' + icons[k]}></i></span> */}
                            <h1>{tableData[k]}</h1>
                            <strong className='capitalize'>{k}</strong>
                        </div>
                    </div>))}
                </div>
            </div>
        </div>)
    }
    const renderAgregateEvents = () => {
        return (
            <div className='ess-db-card ess-resource-leave' >
                <h1>Year wise approved leaves ({utitService.dateParser(new Date(), 'YYYY')})</h1>
                <div className='flex leave-chart'>
                    <LeaveYearChart data={leaveTeken} options={lineChartOptions} />
                </div>
            </div>
        )
    }
    return (
        <div className='manager-home grid'>
            <div className='col-6'>
                {renderAgregateLeaves()}
            </div>
            <div className='col-6'>
                {renderAgregateEvents()}
            </div>

            <div className='col-6'>
                {renderResourceLeaves()}
            </div>
            <div className='col-6'>
                {renderCelebrations()}
            </div>
        </div>
    )
}

export default ManagerHome